// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e68b18b","733":"b33c9379","886":"d92b1fea"}[chunkId] + ".chunk.js";
};